import React from 'react'

function Hosptital() {
  return (
    <div>
      hospital
    </div>
  )
}

export default Hosptital
